module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "fade",
    staticClass: "custom-about-us-sections"
  }, _vm._l((_vm.props.sections), function(section, i) {
    return _c('div', {
      staticClass: "custom-about-us-sections__section"
    }, [_c('div', {
      staticClass: "custom-about-us-sections__container"
    }, [_c('div', {
      staticClass: "custom-about-us-sections__body",
      class: {
        'custom-about-us-sections__body--float': i % 2
      }
    }, [_c('div', {
      staticClass: "custom-about-us-sections__title",
      domProps: {
        "innerHTML": _vm._s(section.title)
      }
    }), _c('div', {
      staticClass: "custom-about-us-sections__content",
      domProps: {
        "innerHTML": _vm._s(section.content)
      }
    })]), _c('div', {
      ref: "slide",
      refInFor: true,
      staticClass: "custom-about-us-sections__image",
      class: {
        'custom-about-us-sections__image--float': i % 2
      },
      style: ({
        backgroundImage: 'url(' + section.image + ')'
      })
    }), (section.video) ? _c('div', {
      staticClass: "custom-about-us-sections__video-container"
    }, [_c('a', {
      staticClass: "custom-about-us-sections__video",
      attrs: {
        "href": section.video,
        "target": "_blank",
        "noreferrer": "noreferrer",
        "noopener": "noopener"
      }
    }, [_vm._v("Meet " + _vm._s(section.btntext))])]) : _vm._e()])])
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-31d7a56a","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/components/custom/custom-about-us-sections/custom-about-us-sections.pug
// module id = 634
// module chunks = 1